import mitt, { Emitter } from "mitt";

export type InternalEvents = {
  purchase: void;
  toggleCanvaCta: void;
  editorMounted: void;
  newEditorPageMounted: void;
  oldEditorMounted: void;
  imagesChanged: number;
};

const emitter: Emitter<InternalEvents> = mitt<InternalEvents>();
export default emitter;
